import axios from '../api'

const getHistory = params => {
  return axios({
    url: '/eos/coupon/orderManager/shoppingList/getHistory',
    params
  })
}
const getComboBoxCouponType = params => {
  return axios({
    url: '/eos/coupon/common/getComboBoxByType',
    params
  })
}
const getOrderInfo = params => {
  return axios({
    url: '/eos/coupon/orderManager/getOrderInfo',
    params
  })
}
const cancelOrder = params => {
  return axios({
    url: '/eos/coupon/orderManager/shoppingList/cancelOrder',
    params
  })
}
const getOrderRefundInfo = params => {
  return axios({
    url: '/eos/coupon/orderManager/shoppingList/getOrderRefundInfo',
    params
  })
}
const refundOrder = params => {
  return axios({
    url: '/eos/coupon/orderManager/shoppingList/refundOrder',
    params
  })
}
const downloadHistory = params => {
  return axios({
    url: '/eos/coupon/orderManager/shoppingList/downloadHistory',
    params
  })
}
export default{
  getHistory,
  getComboBoxCouponType,
  getOrderInfo,
  cancelOrder,
  getOrderRefundInfo,
  refundOrder,
  downloadHistory
}
